import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { authV2Messages } from './authV2Messages';
import { useAuthTrialFacts } from './useAuthTrialFacts';

/** The trial pill and line under the signup lead (design: onboarding g1, g8). */
const AuthTrialLineComponent: React.FC = () => {
  const intl = useIntl();
  const facts = useAuthTrialFacts();
  return (
    <div className="au-trial" data-testid="auth-trial-line">
      <span className="au-trial-pill">
        {intl.formatMessage(authV2Messages.trialPill, { days: facts.days, plan: facts.plan })}
      </span>
      <span>{intl.formatMessage(authV2Messages.trialLine, { price: facts.price })}</span>
    </div>
  );
};

export const AuthTrialLine = TypedMemo(AuthTrialLineComponent);
